module.exports = __webpack_public_path__ + "img/744.834737d1.jpg";